import React from "react";
import {
  Grid,
  TextField
} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";

const FormSection = ({ values }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        {values.map((item) => (
          <Grid key={`item-${ item.key }`} item xs={12}>
            <div className={classes.formItem}>
              <div className={classes.formItemTitle}>{item.label}</div>
              <TextField
                fullWidth
                value={item.value}
                variant="outlined"
                className={classes.textField}
              />
            </div>
          </Grid>
        ))}
      </Grid>
    </div>
  )
}
const useStyles = makeStyles(() => ({
  root: {
    marginTop: "16px"
  },

  formItem: {
    marginBottom: 16
  },
  formItemTitle: {
    marginBottom: "8px",
    fontSize: 15,
    color: "#BDBDBD",
    lineHeight: "18px",
  },
  textField: {
    "& .MuiInputBase-root": {
      background: "#FFFFFF0D",
      border: "1px solid #FFFFFF1A",
    },
    "& .MuiOutlinedInput-input": {
      color: "white",
      cursor: "text",
    },
    "& .MuiInputBase-input": {
      cursor: "text",
    },
  },
}));
export default FormSection;
